import Vue from 'vue'

import * as types from './mutation_types'

const READ_AT_KEY = '__read_at'

function loading(state) {
  state.activeRequests++
}

function loaded(state) {
  state.activeRequests--
}

export default {
  /**
   * Keep count of active requests
   */
  [types.LOADING](state, value) {
    if (value) {
      state.activeRequests++
    } else {
      state.activeRequests--
    }
  },

  [types.LOGIN](state, session) {
    Vue.set(state, 'session', session)
  },

  [types.LOGOUT](state) {
    Vue.set(state, 'session', {})
    Vue.set(state, 'currentUser', {})
    Vue.set(state, 'userReadAt', null)
  },

  [types.PREVIOUS_ROUTE](state, route) {
    Vue.set(state, 'previousRoute', route)
  },

  [types.WHITE_LABEL](state, value) {
    Vue.set(state, 'whiteLabel', value)
  },

  [types.REQUEST_USER](state) {
    loading(state)
  },

  [types.REQUESTED_USER](state) {
    loaded(state)
  },

  // TODO: differenciate betweeen receive current user and  receive any user
  [types.RECEIVE_USER](state, {user, readAt}) {
    Vue.set(state, 'currentUser', user)
    Vue.set(state, 'userReadAt', readAt)
  },

  [types.REQUEST_COMPANY](state) {
    loading(state)
  },

  [types.REQUESTED_COMPANY](state) {
    loaded(state)
  },

  [types.RECEIVE_COMPANY](state, {id, company, readAt}) {
    company[READ_AT_KEY] = readAt

    let companies = state.companies.filter((company) => {
      return company.id !== id
    })

    companies.unshift(company)

    Vue.set(state.companiesById, id, company)
    Vue.set(state, 'companiesList', companies)
  }
}
